import { cn } from "@omni/utils/styles";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { Label } from "@/components/Product/Label/label";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const WebOnly = () => {
    const { t } = useGranite();
    const { isWebOnly } = useECommerceProduct();

    if (!isWebOnly) {
        return null;
    }

    return (
        <Label
            position={"left"}
            type={"label"}
            className={cn("tw:uppercase")}
        >
            <Label.Entry>{t("pricing.webOnly")}</Label.Entry>
        </Label>
    );
};

export { WebOnly };
